// TypoVariants.cs, line for line: every distinct edit-distance-1 variant of
// a token -- each adjacent transposition, then each single-letter
// substitution with a-z -- in that order. Tokens under 4 code units give
// none.
export const TYPO_MIN_TOKEN_LENGTH = 4
const ALPHABET = 'abcdefghijklmnopqrstuvwxyz'

export const typoVariants = token => {
  const out = []
  if (!token || token.length < TYPO_MIN_TOKEN_LENGTH) return out

  const seen = new Set()
  const add = variant => {
    if (!seen.has(variant)) {
      seen.add(variant)
      out.push(variant)
    }
  }

  const buf = token.split('')
  for (let i = 0; i < buf.length - 1; i++) {
    if (buf[i] === buf[i + 1]) continue
    ;[buf[i], buf[i + 1]] = [buf[i + 1], buf[i]]
    add(buf.join(''))
    ;[buf[i], buf[i + 1]] = [buf[i + 1], buf[i]]
  }

  for (let i = 0; i < buf.length; i++) {
    const original = buf[i]
    for (let a = 0; a < ALPHABET.length; a++) {
      const letter = ALPHABET[a]
      if (letter === original) continue
      buf[i] = letter
      add(buf.join(''))
    }
    buf[i] = original
  }

  return out
}
